import React from 'react';
import { TacticalBackground } from './components/TacticalBackground';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { PricingCTASection } from './components/PricingCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="relative min-h-screen bg-tactical-dark overflow-x-hidden selection:bg-tactical-cyan selection:text-tactical-dark" data-id="element-0">
      <TacticalBackground data-id="element-1" />

      <main className="relative z-10" data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <DeliverablesSection data-id="element-6" />
        <AudienceSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <ProofSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <PricingCTASection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}